module.exports = __webpack_public_path__ + "static/media/galerija_2022_0040.5e2cd13c.jpg";